import { Directive, Input, AfterViewInit, HostListener, ElementRef, ContentChild } from '@angular/core';
import { IconPlusMinusToggleComponent } from '../components/icon-plus-minus-toggle/icon-plus-minus-toggle.component';
import { IconCaretComponent } from '../components/icon-caret/icon-caret.component';

@Directive({
  selector: '[appToggleHeight]',
  standalone: true,
})
export class ToggleHeightDirective implements AfterViewInit {
  @Input() containerRef: HTMLElement;
  @Input() isInitiallyOpen: boolean = false;
  @ContentChild(IconCaretComponent) caretIcon: IconCaretComponent;
  @ContentChild(IconPlusMinusToggleComponent) plusMinusIcon: IconPlusMinusToggleComponent;

  private isOpen: boolean;
  constructor(private btnRef: ElementRef) {}

  @HostListener('click')
  handleClick() {
    this.toggleSection();
  }

  ngAfterViewInit() {
    this.isOpen = this.isInitiallyOpen;
    this.containerRef.style.transition = 'height 0.35s ease';
    this.containerRef.style.overflow = 'hidden';

    if (this.isOpen) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  toggleSection() {
    if (this.isOpen) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  private expand() {
    this.containerRef.style.height = `${this.containerRef.scrollHeight}px`;
    this.btnRef.nativeElement.ariaExpanded = 'true';
    this.isOpen = true;
    if (this.caretIcon) {
      this.caretIcon.direction = 'up';
    } else if (this.plusMinusIcon) {
      this.plusMinusIcon.isClosed = false;
    }
  }

  private collapse() {
    this.containerRef.style.height = `0`;
    this.btnRef.nativeElement.ariaExpanded = 'false';
    this.isOpen = false;

    if (this.caretIcon) {
      this.caretIcon.direction = 'down';
    } else if (this.plusMinusIcon) {
      this.plusMinusIcon.isClosed = true;
    }
  }
}
